import { Link as LinkType } from 'datocms-structured-text-utils';
import { ReactNode } from 'react';

import Link, { LinkProps } from 'components/@common/Link';

interface Props {
  node: LinkType;
  children: ReactNode;
  variant?: LinkProps['variant'];
}

const StructuredLink = ({ node, children, variant }: Props) => {
  const meta =
    node.meta?.reduce<Record<string, string>>((memo, meta) => {
      memo[meta.id] = meta.value;
      return memo;
    }, {}) ?? {};

  return (
    <Link
      rel={meta['target'] === '_blank' ? 'noopener noreferrer' : undefined}
      href={node.url}
      variant={variant ? variant : 'body1'}
      underline="always"
      fontWeight="bold"
      textTransform="none"
      letterSpacing={0}
      color="text.primary"
      {...meta}
    >
      {children}
    </Link>
  );
};

export default StructuredLink;
